import { useContext } from 'react';
import {
  PromptTreeContext,
  PromptTreeContextProps,
} from '../context/PromptTreeContext';

const useTreePrompt = (): PromptTreeContextProps =>
  useContext(PromptTreeContext);

export default useTreePrompt;
